import { Box } from '@mui/material';
import React from 'react';
import {
    formatMaintenanceDurationLiteral,
    MAINTENANCE_DOWNTIME_SUFFIX,
} from '../../helpers/printersOverview';

/**
 * Duração em destaque (ex.: 1h30min) + sufixo secundário.
 */
export default function MaintenanceDowntimeText({
    totalMinutes,
    durationSx = {},
    suffixSx = {},
}) {
    if (!totalMinutes || totalMinutes <= 0) {
        return null;
    }

    const duration = formatMaintenanceDurationLiteral(totalMinutes);

    return (
        <>
            <Box
                component="span"
                sx={{
                    color: 'primary.main',
                    fontWeight: 700,
                    ...durationSx,
                }}
            >
                {duration}
            </Box>
            <Box
                component="span"
                sx={{
                    color: 'text.secondary',
                    fontWeight: 'inherit',
                    ...suffixSx,
                }}
            >
                {MAINTENANCE_DOWNTIME_SUFFIX}
            </Box>
        </>
    );
}
